module.exports = {
  zcheck: {
    hd0: "Checking protocols by QR code",
    hd1: "Protocol №",
    hd2: " from ",
    hd3: " found in the database of laboratory LLC &quot;SmartTeamDev&quot;",
    hd4: "This conclusion was not found in the database of the laboratory LLC&quot;SmartTeamDev&quot;",
    ls1: "Line / workpiece / product: ",
    ls2: "Project number: ",
    ls3: "Group of technical devices: ",
    ls4: "Protocol issued by inspector: ",
    ls5: "Control method / Type of test: ",
    lg1: "Verification the laboratory protocol by its number",
    btn1: "Find the protocol",
    att1: "Attachments"
  },
  spfile: {
    zattachment: "Attachment to the conclusion",
    download: "Download file",
    filenotfound: "File is not found",
    loading: "Data loading...",
    openconclusion: "Show the protocol data",
    error: "Error to get file buffer",
    openfile: "Open file"
  },
  pdf: {
    hd0: "Converting Office files to PDF",
    lb1: "* Format files are supported: DOC, DOCX, DOCM, RTF, XLS, XLSX, XLSM, JPEG, PNG",
    lb2: "Select a file (or drag the file here)",
    btn1: "SEND"
  }
};
